import { log, logE } from "../../shared/services/debug-logger";
import { classifyAuthLoginIssue, type AuthLoginLocationState } from "../services/authLoginError";
import { oktaAuth } from "../services/oktaAuth";
import { setSessionStartNow } from "../state/sessionStartStorage";
import { useEffect } from "react";
import { useNavigate } from "react-router";

export function Callback() {
  const navigate = useNavigate();

  useEffect(() => {
    log("Callback - INIT");
    let isActive = true;

    async function handle() {
      try {
        const query = window.location.search;
        const isFromSSO = query.includes("fromLogin=true");

        // When we use employee login, we use the SSO workflow
        // But it requires two round trips to the okta system
        // The first trip primes their identity information with the result from azure ad
        // The second allows us to use that information and not need another sign in
        if (isFromSSO) {
          log("Callback - handle - SSO redirect");
          await oktaAuth.signInWithRedirect();
          return;
        }

        if (oktaAuth.isLoginRedirect()) {
          await oktaAuth.handleRedirect();
          setSessionStartNow();
          log("Callback - handle - login complete");
          return;
        }

        if ((await oktaAuth.isAuthenticated()) === false) {
          log("Callback - handle - sign in redirect");
          await oktaAuth.signInWithRedirect();
          return;
        }

        navigate("/");
        log("Callback - handle - home");
      } catch (error: unknown) {
        logE(new Error("Callback - handle - failed"));

        if (!isActive) {
          return;
        }

        const state = {
          authLoginIssue: classifyAuthLoginIssue(error) ?? "unknown",
        } satisfies AuthLoginLocationState;

        navigate("/login", { replace: true, state });
      }
    }

    handle();

    return () => {
      isActive = false;
    };
  }, [navigate]);

  return (
    <div className="flex items-center gap-4">
      <h1>Logging you in... </h1>
      <div className="loader">...</div>
    </div>
  );
}
